import { useCallback } from 'react';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface ManagerList {
  clientId: number;
  contact: string;
}

const useGetManagerApi = () => {
  const call = useCallback(
    () =>
      new Promise<ManagerList[]>(async (resolve, reject) => {
        try {
          const response = await axiosInstance.get<ManagerList[]>('Supplier/Manager');
          resolve(response.data);
          return response.data;
        } catch (error) {
          console.error(error);
          reject(error);
          throw new Error(error.message);
        }
      }),
    []
  );
  const { value, isLoading } = useAsync(call, true);

  return { managers: value, isManagerLoading: isLoading } as const;
};

export default useGetManagerApi;
